import { Link, Text } from '@change/ds-core-ui/next';

import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';

// eslint-disable-next-line @change/sibling-module-imports
import { BadgeScore } from 'src/app/shared/components/badgeScore/index_new';
import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { usePetitionStrengthScore } from './hooks/usePetitionStrengthScore';

export function PetitionStrengthScore() {
	const { data, actions } = usePetitionStrengthScore();

	return (
		<div className="flex w-full items-center justify-center border-none border-[#E1DDE9] p-6 md:p-5 lg:border-l-[1px] lg:border-solid">
			<div className="flex flex-col items-center gap-6">
				<div className="flex items-center gap-1">
					<Text as="h3" variant="heading" size="x-small" id="petition-strength-title" data-qa="petition-strength-title">
						<Translate value="corgi.petition.starter_dashboard.petition_overview.strength_score.title" />
					</Text>
					<InfoTooltip data-qa="petition-strength-tooltip" aria-describedby="petition-strength-title">
						<TranslateHtml value="corgi.petition.starter_dashboard.petition_overview.strength_score.tip" />
					</InfoTooltip>
				</div>
				<BadgeScore score={data.score} />
				{data.score < 10 && (
					<Link
						variant="secondary"
						bold
						size="small"
						data-qa="improve-strength-rating-link"
						href={data.petitionStrengthUrl}
						onClick={actions.improveStrengthLinkClick}
					>
						<Translate value="corgi.petition.starter_dashboard.petition_overview.strength_score.improve_link" />
					</Link>
				)}
			</div>
		</div>
	);
}
